export const encodeHtmlSymbols = string => {
  return string?.replace(/</gi, "&lt;").replace(/>/gi, "&gt;").replace(/'/gi, "&#39;");
};

export const decodeHtmlSymbols = string => {
  return string?.replace(/&#39;/gi, "'").replace(/&gt;/gi, ">").replace(/&lt;/gi, "<").replace(/%g%/gi, "'");
};
